import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { RiskMatrixBand } from '../admin/risk-matrices/risk-matrix-band';

export class OrgTreeNodeModelRunCategory implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Org Tree Node Model Category';
  public readonly apiRoute: string;

  orgTreeNodeModelRunCategoryId: string;
  modelCategoryId: string;
  orgTreeNodeModelRunId: string;
  consequenceCalibrationId: string;
  probabilityCalibrationId: string;
  riskMatrixBandId: string;
  riskMatrixBand: RiskMatrixBand;
  categoryNodeOutputId: string;
  isOverall: boolean;
  createdBy: string;
  createdDate: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.orgTreeNodeModelRunCategoryId = data.orgTreeNodeModelRunCategoryId;
    this.modelCategoryId = data.modelCategoryId;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;
    this.consequenceCalibrationId = data.consequenceCalibrationId;
    this.probabilityCalibrationId = data.probabilityCalibrationId;

    this.riskMatrixBandId = data.riskMatrixBandId;

    if (data.riskMatrixBand) {
      this.riskMatrixBand = new RiskMatrixBand();
      this.riskMatrixBand.loadFromJson(data.riskMatrixBand);
    }

    this.categoryNodeOutputId = data.categoryNodeOutputId;
    this.isOverall = data.isOverall;

    this.createdBy = data.createdBy;
    this.createdDate = data.createdDate;
  }
}
